module.exports = __webpack_public_path__ + "img/abrir caja icon.cd3e2196.svg";